<template>
    <small-dialog
        @ok="changePassword"
        v-model="dialog"
        :title="title"
        :subtitle="subtitle"
        okButton="ganti"
        loading="changePassword"
        no-activator
    >
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

const DEFAULT_PASSWORD = '123456'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        user: null,
        dialog: false,
    }),

    computed: {
        title() {
            return this.user ? `Ganti Password ${this.user.name}` : ''
        },

        subtitle() {
            return this.user ? this.user.university : ''
        }
    },

    methods: {
        show(user) {
            this.user = user
            this.dialog = true
        },

        async changePassword() {
            let response = await this.$api.patch(`user/${this.user.id}`, {
                password: DEFAULT_PASSWORD
            }, {
                loader: 'changePassword'
            })

            if (response.data.updated) {
                this.$store.dispatch('flash/info', 'Password telah di reset')
                this.dialog = false
                this.user = null
            }
        }
    },
}
</script>
